import { AutoRulesService } from '@weave/schema-gen-ts/dist/schemas/messaging/auto-rules/v1/service.pb';
import { IntegrationsService } from '@weave/schema-gen-ts/dist/schemas/syncapp/integrations-service/integrations_service.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaAutoRules = bindHTTP(AutoRulesService);
export const SchemaIntegrationsService = bindHTTP(IntegrationsService);
